import React from 'react'
import { ButtonGroup, ToggleButton } from 'react-bootstrap'
import { StatusFilterOptions } from './StatusFilterOptions'
import map from 'lodash/map'
import { useInvoiceListContext } from '../Context'

export const StatusPicker = () => {
  const { invoiceFilters } = useInvoiceListContext()

  const [status, setStatus] = invoiceFilters.statusFilter

  return (
    <ButtonGroup>
      {map(StatusFilterOptions, (item) => (
        <ToggleButton
          key={item.name}
          id={`radio-${item.name}`}
          type="radio"
          variant="primary"
          name="radio"
          value={item.name}
          checked={status.name === item.name}
          onChange={() => setStatus(item)}
        >
          {item.name}
        </ToggleButton>
      ))}
    </ButtonGroup>
  )
}
